import classNames from 'classnames';
import React from 'react';
import Layout from '../../Layout';

import { Button } from 'rsuite';
import styles from './SetupIPACategoryLevelsCategoryLevelsButtons.module.scss';

const { Section } = Layout;

export const SetupIPACategoryLevelsCategoryLevelsButtons = () => {
  return (
    <Section.Root>
      <div className={classNames(styles.container)}>
        <Button appearance="ghost" type="button" className={styles.cancel}>
          Cancelar
        </Button>
        <Button appearance="primary" type="submit" className={styles.save}>
          Salvar
        </Button>
      </div>
    </Section.Root>
  );
};
